function setLoadIn(data) {
	return {
		type: 'SET_LOAD_IN',
		payload: data,
	};
}

export { setLoadIn };
